import React, { createContext, useState, useEffect, useContext, } from 'react';
import { useSandboxContext } from '../sandbox/SandboxContext';
import { useLocaleContext } from '../sandbox/useLocaleContext';
const NlsContext = createContext(null);
export const NlsConsumer = NlsContext.Consumer;
export const NlsContextProvider = (props) => {
    const { nlsConfigName, nlsLoaderFactory } = props;
    if (typeof (nlsLoaderFactory === null || nlsLoaderFactory === void 0 ? void 0 : nlsLoaderFactory.requireNlsForLocale) !== 'function') {
        throw new Error('Please provide an nls loader factory into your Context Provider for NLS');
    }
    const sandbox = useSandboxContext();
    const locale = useLocaleContext();
    const [appStrings, setAppStrings] = useState(null);
    useEffect(() => {
        if (nlsConfigName) {
            nlsLoaderFactory.requireNlsForLocale(nlsConfigName, locale.localeCode)()
                .then((x) => {
                var _a;
                if (x && Object.entries(x).length > 0) {
                    setAppStrings(x);
                }
                else if ((_a = sandbox === null || sandbox === void 0 ? void 0 : sandbox.logger) === null || _a === void 0 ? void 0 : _a.error) {
                    sandbox.logger.error('Unable to load nls key');
                }
            });
        }
    }, [props.nlsConfigName]);
    return React.createElement(NlsContext.Provider, { value: appStrings }, props.children);
};
export const useNlsContext = () => useContext(NlsContext);
//# sourceMappingURL=NlsContext.js.map